import { Rule } from "antd/lib/form";

export const addUserAddressFormRules = {
    name: (): Rule[] => [{ required: true, max: 255 }],
    address_1: (): Rule[] => [{ required: true, max: 255 }],
    address_2: (): Rule[] => [{ required: false, max: 255 }],
    city: (): Rule[] => [{ required: true, max: 255 }],
    comment: (): Rule[] => [{ required: false, max: 255 }],

};